import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'

export const url = '/libraries/management/types/country/entries'

@Injectable()
export class CountryService {
    constructor(private http: HttpService) {}
    getAll(): Observable<any[]> {
        return this.http.get(url)
    }
}
